import React, { cloneElement } from 'react';
import { AppMenuList, AppNavOverflowButton } from '@m/alchemy-ui';
import { Link } from 'react-location';
import { FormattedMessage, useIntl } from 'react-intl';
import { RouteLink } from '../../../common/interfaces';
import * as Styled from '../Navigation.styled';
import { useRuntimeUser } from '../../../context';
import { PageType } from '../../../common/enums';

export const languageIsoMatch = (l1: string, l2: string) =>
  l1.toLowerCase().replace(/[^a-zA-Z]/g, '') === l2.toLowerCase().replace(/[^a-zA-Z]/g, '');

export const OverflowMenu = ({ isLoggedIn, links }: { isLoggedIn: boolean; links?: RouteLink[] }) => {
  const intl = useIntl();
  const { displayName, avatar } = useRuntimeUser();

  const renderOverflow = (children: React.ReactElement[]) => (
    <AppNavOverflowButton
      overflowListItems={children}
      overlay={() => <AppMenuList>{children.map((child) => cloneElement(child, { isOverflowed: true }))}</AppMenuList>}
    />
  );

  return (
    <Styled.OverflowCollapse
      // @ts-expect-error -- renderOverflow should allow for ReactElement
      renderOverflow={renderOverflow}
      wrapperElement="ul"
      overflowElement="li"
      aria-label={intl.formatMessage({ id: 'navigation', defaultMessage: 'Navigation' })}
      spacing={12}
    >
      {isLoggedIn && (
        <Styled.AppNavListItem key="login">
          <Link
            to="user/ideastream"
            getActiveProps={() => ({
              className: Styled.ACTIVE_OVERFLOW_LINK_CLASSNAME
            })}
          >
            {avatar ? (
              <Styled.NavProfileImage src={avatar} alt={displayName} data-testid="UserAvatar" />
            ) : (
              <Styled.UserIcon />
            )}
            <FormattedMessage id="myProfile" defaultMessage="My Profile" />
          </Link>
          <Styled.AppNavSeparator />
        </Styled.AppNavListItem>
      )}
      {links?.map(({ linkTitle, url, type, newWindow }, index) => (
        <Styled.AppNavListItem key={url}>
          {type === PageType.URL ? (
            <a href={url} target={newWindow ? '_blank' : ''}>
              {linkTitle}
            </a>
          ) : (
            <Link
              to={index === 0 ? '/' : url}
              getActiveProps={() => ({
                className: Styled.ACTIVE_OVERFLOW_LINK_CLASSNAME
              })}
            >
              {linkTitle}
            </Link>
          )}
        </Styled.AppNavListItem>
      ))}
    </Styled.OverflowCollapse>
  );
};
